var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import VetGuide1Img from '@images/marketing/Vet-Guide1.jpg';
import VetGuide2Img from '@images/marketing/Vet-Guide2.jpg';
import VetGuide3Img from '@images/marketing/Vet-Guide3.jpg';
import VetHero from '@images/marketing/Vet-Hero.jpg';
import WSAVAImg from '@images/marketing/Vet-WSAVA.jpg';
var vetHeroContent = {
    heroImage: {
        src: VetHero,
        alt: 'A happy dog with its ears up, licking its lips',
        width: 558,
        height: 363,
    },
    headline: 'A Guide for Veterinarians',
    subhead: "Our gently cooked dog food is formulated by a board-certified\n  veterinary nutritionist and PhD scientists, for the complete and balanced nutrition dogs need.",
};
var vetBenefits = {
    headline: "The Benefits of Nom Nom's Vet-Developed Food",
    benefits: [
        {
            title: 'Easy to Digest',
            description: "Besides improving utilization of nutrients, Nom Nom\u2019s high\n      digestibility means that less undigested proteins make it to the colon,\n      which can result in bacterial fermentation and production on undesired\n      compounds such as phenols, indoles and branched chain amino acids which\n      increase fecal odor.",
        },
        {
            title: 'High Moisture Content',
            description: "Nom Nom\u2019s gently cooked recipes are naturally high in\n      moisture (70-75% on average). This helps aid in hydration, and can have\n      benefits to the dog\u2019s urinary health and food intake.",
        },
        {
            title: 'Stimulating Feeding Experience',
            description: "Nom Nom's gently cooked diets offer excellent palatability and\n      add enrichment to a dog's meal, by introducing more ingredient textures\n      and flavors than traditional formats.",
        },
        {
            title: 'Personalized Portions',
            description: "We look at each dog's age, weight, activity level and other important factors,\n      and pair this information with an algorithm that was developed by our scientists and informed\n      by the most recent research in vet nutrition, to determine their approximate metabolism and\n      caloric needs and pre-portion their meals.",
        },
        {
            title: 'Uncompromising Quality and Food Safety',
            description: "Meals are prepared in our kitchen facilities in Nashville. We take\n      responsibility for each step of the process so we can maintain oversight\n      and quality. That\u2019s why we inspect every ingredient and rigorously test\n      for safety, to provide high quality meals from small, made-to-order\n      batches.",
        },
    ],
};
var WSAVAGuidelinesFeaturetteContent = {
    headline: 'WSAVA Guidelines for Selecting Dog Food',
    heroImage: { src: WSAVAImg, alt: 'Multicolored bowls of delicious Nom Nom dog food' },
    subhead: "WSAVA Guidelines evaluate each company in relation to their nutritional\n  expertise, food safety and quality control practices, and whether they're\n  active in nutrition research. Nom Nom's products and manufacturing processes\n  meet or exceed WSAVA's guidelines.",
};
var WSAVAFAQs = {
    headline: "WSAVA FAQ's",
    faqs: [
        {
            question: 'What kind of research or nutrition studies have been conducted? Is it published in peer review journals?',
            answer: (_jsxs(_Fragment, { children: ["Nom Nom backs up all of our products with feeding studies. These feeding studies are conducted on all formulas, to ensure product performance according to Nom Nom\u2019s high palatability and digestibility standards. Nom Nom has published multiple peer-reviewed studies to support products and services, and", ' ', _jsx("a", __assign({ className: "docs-link", href: "https://www.nomnomnow.com/learn/research-and-development?srsltid=AfmBOoqDMmNUuDo6aPVuYiXh8oHi77xJhtc6wJ7rxJygpml3N0bV3Sv8" }, { children: "add to pet health public knowledge" })), "."] })),
        },
        {
            question: 'Who formulates the diet? What is the quality control process for ingredients and finished products?',
            answer: (_jsx(_Fragment, { children: "Nom Nom\u2019s food is produced in its own Nashville, Tennessee-based packaging facility. The company is backed by Mars and Royal Canin regulatory, ensuring claims are up to snuff, and supported by Mars and Royal Canin Q&FS standards, so you can be confident in the quality. Nom Nom meets all AAFCO guidelines and regulations, and is formulated to meet the canine AAFCO nutrient profile for all life stages." })),
        },
        {
            question: 'Do they employ a nutritionist?',
            answer: (_jsx(_Fragment, { children: "Nom Nom\u2019s recipes have always been developed under the guidance of a board certified veterinary nutritionist. Today, together with Nom Nom\u2019s own Matthew Brooks, MS, PhD Small Animal Nutritionist, we\u2019re supported by a team of expert nutritionists within the Mars and Royal Canin family." })),
        },
    ],
};
var learnMore = {
    headline: 'Want to Learn More?',
    subhead: "Read our Product Reference Guide to get details on our recipes' macronutrient profiles and more.",
    ctaUrl: 'https://storage.googleapis.com/nom-nom-now/VetGuide.pdf',
    isExternalLink: true,
    buttonLabel: 'View PDF',
    imageData: [
        {
            src: VetGuide1Img,
            alt: "Cover of Nom Nom's Product Reference Guide",
        },
        { src: VetGuide2Img, alt: 'Inside the reference guide, the intro to the recipe section' },
        { src: VetGuide3Img, alt: 'Inside the reference guide, the final page' },
    ],
};
export { learnMore, vetBenefits, vetHeroContent, WSAVAGuidelinesFeaturetteContent, WSAVAFAQs };
